import { FormattedMessage } from "react-intl";
import {
  FacebookShare,
  LinkedinShare,
  TwitterShare,
} from "component/SocialMediaComponent/SocialMediaComponent.jsx";

function ShareButtons({ publication }) {
  const url = `${window.location.href}`;
  const title = publication?.name;

  return (
    <div className="share-t row align-items-center">
      <div className="col-lg-4 col-6">
        <h6 className="mb-0">
          <FormattedMessage id="share-publication" />
        </h6>
      </div>
      <div className="col-lg-8 col-6">
        <div className="d-flex gap-2">
          <div>
            <FacebookShare url={url} title={title}>
              <div className="item-link">
                <i className="icon fab fa-facebook-f"></i>
              </div>
            </FacebookShare>
          </div>
          <div>
            <TwitterShare url={url} title={title}>
              <img
                className="img1"
                src={process.env.PUBLIC_URL + "/image/X-small.png"}
                height={32}
                width={32}
                alt="X"
                loading="lazy"
              />
            </TwitterShare>
          </div>
          <div>
            <LinkedinShare
              url={url}
              title={title}
              brief={publication?.description}
            >
              <div className="item-link">
                <a href="">
                  <i className="icon fab fa-linkedin-in"></i>
                </a>
              </div>
            </LinkedinShare>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShareButtons;
